import React, { useEffect, useState } from 'react'
import axios from 'axios';
import toast, { LoaderIcon } from 'react-hot-toast';
import { FaArrowAltCircleLeft } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

import { useStateProvider } from '../../manager/StateContext';
import TextInput from '../TextInput';

import { sendError, setNextTab } from '../../utils/helpers';
import { colors } from '../../utils/style';

const KinDetails = ({
  activeTab,
  tab,
  setActiveTab,
  isLoading,
  setIsLoading,
  handlePrev,
}) => {
  // const { accessToken } = useSelector((state) => state.auth);
  const [{ user_data, token }] = useStateProvider();

  const navigate = useNavigate();

  const initialData = JSON.parse(localStorage.getItem("kinData")) || {
    next_of_kin_name: "",
    next_of_kin_address: "",
    next_of_kin_mobile: "",
    next_of_kin_relationship: "",
  };
  const [kinData, setKinData] = useState(initialData);

    useEffect(() => {
      localStorage.setItem("kinData", JSON.stringify(kinData));
    }, [kinData]);

  const handleKinChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setKinData((kinDAta) => ({
        ...kinDAta,
        [name]: value,
      }));
    }
  };

  const handleUpdateKin = () => {
    Swal.fire({
      title: "Update Next of Kin Details",
      text: "Are you sure you want to update your next of kin details?",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      cancelButtonColor: "red",
      confirmButtonColor: "#00aaff",
      customClass: {
        title: "swal2-title-custom",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const config = {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          };

          setIsLoading(true);

          const url = `${process.env.REACT_APP_API_URL}/api/v1/cooperate/health-worker/update-health-worker-information/${user_data?.id}`;

          axios
            .put(url, { ...kinData }, config)
            .then((response) => {
              setIsLoading(false);
              const { data } = response;
              toast.success(data.message);

              navigate("/health-worker/completed");
            })
            .catch((error) => {
              setIsLoading(false);
              const message = sendError(error);
              console.log(message);
              toast.error(message.message);
            });
        } catch (error) {
          setIsLoading(false);
          const message = sendError(error);
          toast.error(message.error);
        }
      }
    });
  };

  return (
    <div className="mx-5 flex-1">
      <h5 className="text-[15px] font-semibold">Next of Kin Details</h5>
      <p className="text-[10px]">Let us know your next of kin information.</p>

      <div className="my-2 grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
        <div>
          <TextInput
            label="Next of Kin Full Name"
            type="text"
            id="next_of_kin_name"
            name="next_of_kin_name"
            value={kinData.next_of_kin_name}
            onChange={handleKinChange}
            className="w-[150px] focus:ring-bgbutton focus:border-bgbutton number-input"
          />
        </div>

        <div>
          <TextInput
            label="Relationship with Kext of Kin"
            type="text"
            id="next_of_kin_relationship"
            name="next_of_kin_relationship"
            value={kinData.next_of_kin_relationship}
            onChange={handleKinChange}
            className="w-[150px] focus:ring-bgbutton focus:border-bgbutton number-input"
          />
        </div>

        <div>
          <TextInput
            label="Next of Kin Phone Number"
            type="text"
            id="next_of_kin_mobile"
            name="next_of_kin_mobile"
            value={kinData.next_of_kin_mobile}
            onChange={handleKinChange}
            className="w-[150px] focus:ring-bgbutton focus:border-bgbutton number-input"
          />
        </div>

        <div>
          <TextInput
            label="Next of Kin Address"
            type="text"
            id="next_of_kin_address"
            name="next_of_kin_address"
            value={kinData.next_of_kin_address}
            onChange={handleKinChange}
            className="w-[150px] focus:ring-bgbutton focus:border-bgbutton number-input"
          />
        </div>
      </div>

      <div className="flex items-center justify-between mt-4 w-full">
        <div className="flex cursor-pointer items-center space-x-2 mr-2">
          <div onClick={handlePrev} className="flex items-center space-x-1">
            <FaArrowAltCircleLeft size={25} color={colors.primary} />
            <p className="font-bold">Back</p>
          </div>
        </div>

        <button onClick={handleUpdateKin} className="button">
          <div className="flex items-center space-x-3">
            {isLoading && <LoaderIcon size="20" color="white" />}
            <p>Update</p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default KinDetails